export enum DocumentType {
  INVOICE = "Invoice",
  RATECON = "RateCon",
  OTHER = "Other",
  BillOfLading = "BillOfLading",
  ProofOfDelivery = "ProofOfDelivery",
}
